import {
  selectLessonPlannerWorkbook,
  selectLessonPlannerNavbarChange,
  setLessonPlanCurrentWeek,
  setLessonPlanDay
} from './actions';
import { ThunkAction, Dispatch } from './types';

export function setLessonPlannerWorkbook(workbook: string): ThunkAction {
  return async (dispatch: Dispatch) => {
    dispatch(selectLessonPlannerWorkbook(workbook));
  };
}

export function setLessonPlannerNavbarAttribute(attribute: string, value: any): ThunkAction {
  return async (dispatch: Dispatch) => {
    dispatch(selectLessonPlannerNavbarChange(attribute, value));
  };
}

export const setLessonPlanWeek = (weekNumber: number) => {
  return async (dispatch, getState) => {
    const { lessonPlanner } = getState();
    if (weekNumber < lessonPlanner.numberOfWeeks) {
      dispatch(setLessonPlanCurrentWeek(weekNumber));
    }
  };
};

export const incrementLessonPlanWeek = () => {
  return async (dispatch, getState) => {
    const { lessonPlanner } = getState();
    if (lessonPlanner.currentlessonPlanWeek < lessonPlanner.numberOfWeeks) {
      dispatch(setLessonPlanCurrentWeek(lessonPlanner.currentlessonPlanWeek + 1));
    }
  };
};

export const decramentLessonPlanWeek = () => {
  return async (dispatch, getState) => {
    const { lessonPlanner } = getState();
    if (lessonPlanner.currentlessonPlanWeek > 1) {
      dispatch(setLessonPlanCurrentWeek(lessonPlanner.currentlessonPlanWeek - 1));
    }
  };
};

export const setLessonPlanToDate = (weekNumber: number, dayNumber: number) => {
  return async (dispatch, getState) => {
    const { lessonPlanner } = getState();
    if (weekNumber < lessonPlanner.numberOfWeeks) {
      dispatch(setLessonPlanCurrentWeek(weekNumber));
      dispatch(setLessonPlanDay(dayNumber));
    }
  };
};

export const incrementLessonPlanDay = () => {
  return async (dispatch, getState) => {
    const {
      lessonPlanner: { currentDay },
      lessonPlanner
    } = getState();
    if (lessonPlanner.currentlessonPlanWeek < lessonPlanner.numberOfWeeks) {
      if (currentDay === 4) {
        dispatch(incrementLessonPlanWeek());
        dispatch(setLessonPlanDay(0));
      } else {
        dispatch(setLessonPlanDay(currentDay + 1));
      }
    }
  };
};
export const decramentLessonPlanDay = () => {
  return (dispatch, getState) => {
    const {
      lessonPlanner: { currentDay },
      lessonPlanner
    } = getState();

    if (lessonPlanner.currentlessonPlanWeek >= 1) {
      if (currentDay > 0) {
        dispatch(setLessonPlanDay(currentDay - 1));
      } else {
        if (lessonPlanner.currentlessonPlanWeek !== 1) dispatch(setLessonPlanDay(4));
        dispatch(decramentLessonPlanWeek());
      }
    }
  };
};
